import { useMemo } from 'react';
import { TileVariant } from '../types/TileVariant';

export function useTileVariantColors(variant: TileVariant) {
	return useMemo(() => {
		switch (variant) {
			case 'low':
				return { backgroundColor: `#D9F5DD`, foregroundColor: '#007500' };

			case 'medium':
				return { backgroundColor: `#FBF0D0`, foregroundColor: '#7E610C' };

			case 'high':
				return { backgroundColor: `#FFE2E0`, foregroundColor: '#CC1100' };

			case 'closed':
			default:
				return { backgroundColor: `#E1E1E1`, foregroundColor: '#383838' };
		}
	}, [variant]);
}
